import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.initial_setup"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(
                VAlert,
                { staticClass: "m-0", attrs: { type: "info", text: "" } },
                [_vm._v(_vm._s("Select one or more items to request!"))]
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "btn-inca-secondary",
                  attrs: {
                    outlined: "",
                    disabled: _vm.tablesSelected.length == 0,
                  },
                  on: { click: _vm.onConfirmRequest },
                },
                [
                  _c(VIcon, [_vm._v("mdi-key-outline")]),
                  _vm._v("Request Access"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VCard,
        [
          _c(VCardText, { staticClass: "pb-0" }, [
            _c(
              "div",
              { staticClass: "d-flex align-center justify-left flex-wrap" },
              [
                _c("div", { staticClass: "mr-6" }, [
                  _c("div", { staticClass: "text-caption grey--text" }, [
                    _vm._v("Área"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-medium text-subtitle-1" },
                    [
                      _c(
                        VIcon,
                        {
                          staticClass: "mr-1",
                          attrs: { small: "", color: "primary" },
                        },
                        [_vm._v("mdi-domain")]
                      ),
                      _vm._v(_vm._s(_vm.areaDescription)),
                    ],
                    1
                  ),
                ]),
                _c("div", [
                  _c("div", { staticClass: "text-caption grey--text" }, [
                    _vm._v("Perfil"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-medium text-subtitle-1" },
                    [
                      _c(
                        VIcon,
                        {
                          staticClass: "mr-1",
                          attrs: { small: "", color: "primary" },
                        },
                        [_vm._v("mdi-account-circle")]
                      ),
                      _vm._v(_vm._s(_vm.userProfile)),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
          _c(VDataTable, {
            ref: "selectableTable",
            staticClass: "table-inca",
            attrs: {
              items: _vm.tables,
              headers: _vm.fields,
              busy: _vm.isBusy,
              outlined: "",
              responsive: "",
              hover: "",
              striped: "",
              "show-select": "",
              "item-key": "index",
              "checkbox-color": "primary",
              "hide-default-footer": "",
              page: _vm.pagination.current,
              "items-per-page": _vm.pagination.limit,
            },
            on: {
              "row-selected": _vm.onRowSelected,
              "toggle-select-all": _vm.onToggleSelected,
              pagination: function ($event) {
                _vm.pagination.total = $event.itemsLength
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "current", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center text-primary my-2" },
                      [
                        _c("b-spinner", {
                          attrs: { variant: "primary", label: "Spinning" },
                        }),
                        _c("strong", [_vm._v("Loading...")]),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "header.selected",
                fn: function (ref) {
                  var data = ref.data
                  return [
                    _vm.checkAll
                      ? [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.hover.top",
                                  value: "Clear All selected",
                                  expression: "'Clear All selected'",
                                  modifiers: { hover: true, top: true },
                                },
                              ],
                              staticClass: "ml-2",
                              on: { click: _vm.selectAllRows },
                            },
                            [_vm._v("✗")]
                          ),
                        ]
                      : [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.hover.top",
                                  value: "Select all",
                                  expression: "'Select all'",
                                  modifiers: { hover: true, top: true },
                                },
                              ],
                              staticClass: "ml-2",
                              on: { click: _vm.selectAllRows },
                            },
                            [_vm._v("✓")]
                          ),
                        ],
                  ]
                },
              },
              {
                key: "item.date_end",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("datetime", {
                      attrs: {
                        id: "load-date-input",
                        type: "date",
                        disabled: true,
                        size: "sm",
                        "input-style":
                          "border: none; opacity:1; background-color: rgb(0 0 0 / 0%); text-align: center",
                      },
                      model: {
                        value: item.date_end,
                        callback: function ($$v) {
                          _vm.$set(item, "date_end", $$v)
                        },
                        expression: "item.date_end",
                      },
                    }),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.tablesSelected,
              callback: function ($$v) {
                _vm.tablesSelected = $$v
              },
              expression: "tablesSelected",
            },
          }),
        ],
        1
      ),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
      _c("b-overlay", {
        attrs: { show: _vm.busy, "no-wrap": "", fixed: "" },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [
                _vm.processing
                  ? _c(
                      "div",
                      [
                        _c("b-spinner", { attrs: { variant: "secondary" } }),
                        _c("p", [_vm._v(_vm._s(_vm.overlay_message) + " ...")]),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        ref: "dialog",
                        staticClass: "text-center p-3",
                        attrs: {
                          tabindex: "-1",
                          role: "dialog",
                          "aria-modal": "false",
                          "aria-labelledby": "form-confirm-label",
                        },
                      },
                      [
                        _c("p", [
                          _c(
                            "strong",
                            { attrs: { id: "form-confirm-label" } },
                            [_vm._v("Are you sure?")]
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mr-3",
                                attrs: {
                                  variant: "outline-danger",
                                  size: "sm",
                                },
                                on: { click: _vm.onCancelRequest },
                              },
                              [_vm._v("Cancel")]
                            ),
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "outline-success",
                                  size: "sm",
                                },
                                on: { click: _vm.sendRequestAccess },
                              },
                              [_vm._v("OK")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: "dialogConfirmation",
        attrs: { title: "Confirmación" },
        on: { onConfirm: _vm.onConfirm },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }